import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { EnterpriseContactSalesPage } from 'features/enterpriseContactSales'

export const Route = createFileRoute('/contact-sales/enterprise')({
  component: EnterpriseContactSalesPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Contact Sales'),
      },
    ],
  }),
})
